export enum TransferStatus {
  OPEN = 'OPEN',
  ACCEPTED = 'ACCEPTED',
  INVALID = 'INVALID',
  REJECTED = 'REJECTED',
  UNKNOWN = 'UNKNOWN',
}

export type TransferRequest = {
  id: string;
  status: { status: TransferStatus };
  bookingId: string;
  newHost: string;
  potentialHosts: { hostId: string; hasRejected: boolean }[];
  cancelExplanation: string;
  expiresAt: string;
  booking: {
    title: string;
    tripDateTime: string;
    tripPrettyDuration: string;
    tripDuration: {
      days: number;
      hours: number;
      minutes: number;
    };
    payment: {
      paymentToHostAmount: number;
      feeAmount: number;
      totalPrice: number;
      priceCurrency: string;
    };
    numberOfChildren: number;
    numberOfAdults: number;
    included: string[];
    notIncluded: string[];
    mainGuestViewModel: {
      firstName: string;
      country: string;
      languages: { language_code: string }[];
      spokenLanguages: string[];
      dayOfBirth: string;
    };
  };
  initialHost: {
    id: string;
    firstName: string;
    photo: string;
  };
};
